var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 12"}},[_c('path',{attrs:{"d":"M12 0H2C.9 0 0 .9 0 2v5c0 1.1.9 2 2 2h6.2l3.8 3V9c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"}})])};var toString = function () {return "/opt/build/repo/src/assets/social-blog.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-blog.svg
// module id = heup
// module chunks = 0